import { Card } from "@mui/material";
import { styled } from "@mui/system";

export const GradientCard = styled(Card)(({ theme, gradient }) => ({
  background: gradient,
  color: theme.palette.common.white,
  boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
  border: 0,
  borderRadius: 16,
}));

export const SectionCard = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  boxShadow: "0 18px 40px rgba(0,0,0,0.06)",
  border: `1px solid ${theme.palette.divider}`,
}));

export const ServiceOptionCard = styled(Card)(({ theme, selected }) => ({
  cursor: "pointer",
  borderRadius: 12,
  transition: "all 0.3s ease",
  border: selected
    ? `2px solid ${theme.palette.success.main}`
    : `1px solid ${theme.palette.divider}`,
  backgroundColor: selected
    ? theme.palette.mode === "dark"
      ? "rgba(76, 175, 80, 0.08)"
      : "rgba(76, 175, 80, 0.04)"
    : theme.palette.background.paper,
  "&:hover": {
    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
    transform: "translateY(-2px)",
  },
}));

export const ProviderCard = styled(Card)(({ theme, selected }) => ({
  cursor: "pointer",
  borderRadius: 12,
  transition: "all 0.3s ease",
  border: selected
    ? `2px solid ${theme.palette.success.main}`
    : `1px solid ${theme.palette.divider}`,
  backgroundColor: selected
    ? theme.palette.mode === "dark"
      ? "rgba(76, 175, 80, 0.08)"
      : "rgba(76, 175, 80, 0.04)"
    : theme.palette.background.paper,
  "&:hover": {
    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
    transform: "translateY(-2px)",
    borderColor: theme.palette.primary.main,
  },
}));
